import { render, staticRenderFns } from "./authSubmit.vue?vue&type=template&id=174be595&scoped=true"
import script from "./authSubmit.vue?vue&type=script&lang=js"
export * from "./authSubmit.vue?vue&type=script&lang=js"
import style0 from "./authSubmit.vue?vue&type=style&index=0&id=174be595&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174be595",
  null
  
)

export default component.exports